import { render, staticRenderFns } from "./riskIndex.vue?vue&type=template&id=d7fa6ab2&scoped=true&"
import script from "./riskIndex.vue?vue&type=script&lang=js&"
export * from "./riskIndex.vue?vue&type=script&lang=js&"
import style0 from "./riskIndex.vue?vue&type=style&index=0&id=d7fa6ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fa6ab2",
  null
  
)

export default component.exports